import { version as packageVersion } from '../package.json';

/**
 * The version of Open Video UI for Web.
 */
export const version: string = packageVersion;
